import React from 'react';
import { Button, Message, Modal } from 'semantic-ui-react';

/**
 * Shared shell of the bulk import wizards (prices/costs and stock): header, close
 * cross, close on outside click, error banner and footer close button.
 * `closeLocked` blocks every way of closing it while an import is running.
 */
const ImportWizardModal = ({
  open,
  title,
  onClose,
  closeLocked = false,
  closeLabel = 'Cerrar',
  lockedCloseLabel = 'Importacion en curso',
  stepHeader,
  error,
  children,
}) => (
  <Modal
    open={open}
    onClose={closeLocked ? undefined : onClose}
    closeIcon={!closeLocked}
    closeOnDimmerClick={!closeLocked}
    closeOnEscape={!closeLocked}
    size="large"
    style={{ height: '92vh' }}
  >
    <Modal.Header>{title}</Modal.Header>
    <Modal.Content scrolling={false} style={{ padding: 0 }}>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '78vh' }}>
        <div style={{ padding: '24px 24px 0' }}>{stepHeader}</div>
        <div
          style={{
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            padding: '0 24px 24px',
            overflow: 'hidden',
          }}
        >
          {error ? <Message negative content={error} style={{ marginBottom: 0 }} /> : null}
          {children}
        </div>
      </div>
    </Modal.Content>
    <Modal.Actions style={{ padding: '16px 24px' }}>
      <Button type="button" onClick={onClose} disabled={closeLocked}>
        {closeLocked ? lockedCloseLabel : closeLabel}
      </Button>
    </Modal.Actions>
  </Modal>
);

export default ImportWizardModal;
